{
 "_meta": {
  "locale": "fr",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Maintenant",
  "people": "Personnes",
  "cases": "Dossiers",
  "agenda": "Agenda",
  "reviews": "Revues",
  "prospects": "Prospection",
  "insights": "Analyses",
  "data": "Données & sécurité",
  "settings": "Paramètres",
  "lens": "Loupe"
 },
 "common": {
  "save": "Enregistrer",
  "cancel": "Annuler",
  "close": "Fermer",
  "search": "Rechercher",
  "today": "Aujourd'hui",
  "tomorrow": "Demain",
  "new": "Nouveau",
  "edit": "Modifier",
  "delete": "Supprimer"
 },
 "settings": {
  "title": "Paramètres",
  "language": "Langue",
  "region": "Marché / région",
  "theme": "Apparence"
 },
 "people": {
  "title": "Personnes",
  "new": "Nouvelle personne"
 },
 "today": {
  "agenda_title": "Aujourd'hui"
 },
 "lens": {
  "placeholder": "Rechercher des personnes, prospects, dossiers — ou taper une commande"
 }
}